import { useIntl } from 'react-intl';

import type { IWorkJourneyManagementCalendarCell } from '@src/models/interfaces/workJourneyManagement.interface';

import { getCalendarWeekdayReferenceDate, CALENDAR_WEEKDAY_OFFSETS } from '@src/packages/workJourney/utils/buildWorkJourneyCalendarGrid';
import { WorkJourneyCalendarDayCell } from '../WorkJourneyCalendarDayCell';
import styles from './styles.module.less';

interface WorkJourneyCalendarGridProps {
  cells: IWorkJourneyManagementCalendarCell[];
  onDayFooterClick?: (cell: IWorkJourneyManagementCalendarCell) => void;
}

export const WorkJourneyCalendarGrid = ({
  cells,
  onDayFooterClick,
}: WorkJourneyCalendarGridProps) => {
  const intl = useIntl();

  return (
    <div className={styles.gridWrapper}>
      <div className={styles.weekdayHeader}>
        {CALENDAR_WEEKDAY_OFFSETS.map(offset => (
          <span key={offset} className={styles.weekdayLabel}>
            {intl.formatDate(getCalendarWeekdayReferenceDate(offset), {
              weekday: 'short',
              timeZone: 'UTC',
            })}
          </span>
        ))}
      </div>

      <div className={styles.grid}>
        {cells.map(cell => (
          <WorkJourneyCalendarDayCell
            key={`${cell.date}-${cell.isCurrentMonth}`}
            cell={cell}
            onFooterClick={onDayFooterClick}
          />
        ))}
      </div>
    </div>
  );
};
